var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_56",
  "data-name": "Group 56",
  transform: "translate(-0.256 0.305)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_36",
  "data-name": "Rectangle 36",
  width: 40,
  height: 40,
  rx: 20,
  transform: "translate(0.256 -0.305)",
  fill: "#008c45"
}), /*#__PURE__*/React.createElement("g", {
  id: "twitter-logo-silhouette",
  transform: "translate(12.252 14.002)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_25",
  "data-name": "Group 25"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M19.7,59.334a8.069,8.069,0,0,1-2.32.636,4.058,4.058,0,0,0,1.776-2.234,8.146,8.146,0,0,1-2.568.981A4.044,4.044,0,0,0,9.7,62.4a11.472,11.472,0,0,1-8.328-4.222,4.045,4.045,0,0,0,1.251,5.394,4.041,4.041,0,0,1-1.83-.507v.05a4.045,4.045,0,0,0,3.241,3.962,4.093,4.093,0,0,1-1.065.142,3.878,3.878,0,0,1-.761-.075,4.043,4.043,0,0,0,3.774,2.806A8.107,8.107,0,0,1,.965,71.678,8.585,8.585,0,0,1,0,71.623a11.422,11.422,0,0,0,6.194,1.818,11.417,11.417,0,0,0,11.5-11.5l-.014-.523A8.069,8.069,0,0,0,19.7,59.334Z",
  transform: "translate(-0.997 -58.748)",
  fill: "#fff"
}))));
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b0a73393e462897651e783c185514ffc.svg";
export { ForwardRef as ReactComponent };